import { SelectOption, SelectOptionGroup, SelectOptions } from '../types'

export function findSelectedOption<T>(options: SelectOptions<T>, value?: T): SelectOption<T> | undefined {
    if (value === undefined) return undefined

    for (const opt of options) {
        if ('options' in opt) {
            // It's a group
            const found = (opt as SelectOptionGroup<T>).options.find(o => o.value === value)
            if (found) return found as SelectOption<T>
        } else {
            const option = opt as SelectOption<T>
            if (option.value === value) return option
        }
    }
    return undefined
}
